import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.css']
})
export class BlogPageComponent {
 blogData: any;
  BaseUrl: any;

constructor(private userService: UserService,private router :Router) { }

ngOnInit() {
this.fetchBlogData();
this.BaseUrl=environment.userApiUrl + '/slider/';
}

fetchBlogData(){
this.userService.fetchBlogData().subscribe({
  next: (data:any) => {
    this.blogData=data?.data;
    console.log("Blog data fetched successfully:", this.blogData);
  }
  , error: (error: any) => {
    console.error("Error fetching blog data:", error);
  }
});
}

  redirectToAsset(id: string) {
    this.router.navigateByUrl('/blog-detail/' + id)
  }
 
}

